import SiteButton_RibbonButtonComponent from '../components/SiteButton/viewer/skinComps/RibbonButton/RibbonButton.skin';
import SiteButton_RibbonButtonController from '../components/SiteButton/viewer/SiteButton.controller';


const SiteButton_RibbonButton = {
  component: SiteButton_RibbonButtonComponent,
  controller: SiteButton_RibbonButtonController
};


export const components = {
  ['SiteButton_RibbonButton']: SiteButton_RibbonButton
};

